<template>
    <div>
        <b-card header-tag="header" class="m-3" no-body>
            <template #header>
                <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
                Envios Sem Movimento
                <b-button size="sm" class="float-right m-1" to="/seguranca-administracao/envios-sem-movimento/novo">
                    <font-awesome-icon icon="plus" class="mr-3" />
                    Novo Envio
                </b-button>
                </h6>
            </template>
            <b-card-body>
                <card-filtros-busca>
                    <b-form @submit.prevent="executarFiltros" @reset.prevent="limparFiltros" v-if="showFilters">
                        <b-row>
                            <b-col cols="8" lg="6" class="wrapper-multiselect-sagres">
                                <b-form-group id="input-group-type" label-size="md" label="Unidade Gestora">
                                <multiselect v-model="filtros.selectedUG" open-direction="bottom" :close-on-select="true"
                                    :searchable="true" label="Nome" :show-labels="false" deselect-label="" :allow-empty="true"
                                    placeholder="Selecione" track-by="Codigo" :options="optionsUG">
                                    <template slot="noOptions">
                                    <small><i>Erro ao obter dados.</i></small>
                                    </template>
                                    <template slot="noResult">
                                    <i>Sem resultados.</i>
                                    </template>
                                </multiselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="4" lg="3" class="pt-4">
                                <b-button style="width:50%; margin-top:5px" type="reset" variant="outline-secondary">
                                <font-awesome-icon icon="redo" class="mr-3" />Limpar
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4" lg="3">
                                <b-form-group id="input-group-type" label-size="md" label="Exercício (ano)">
                                <b-form-select id="select-filtros-exercicio" v-model="filtros.exercicio" :options="comboExercicios">
                                </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col cols="4" lg="3">
                                <b-form-group id="input-group-type" label-size="md" label="Referência (mês)">
                                <b-form-select id="select-filtros-referencia" v-model="filtros.referencia" :options="comboReferencias">
                                </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col cols="4" lg="3" class="pt-4">
                                <b-button style="width:50%; margin-top:5px;" type="submit">
                                <font-awesome-icon icon="search" class="mr-3" />Filtrar
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </card-filtros-busca>
                <b-table :busy="tableBusy" :fields="fields" hover no-border-collapse :items="items" sort-by="" :sort-desc="true"
                    striped stacked="sm" show-empty>
                    <template #empty>
                        <span>Não foram encontrados dados.</span>
                    </template>
                    <template #emptyfiltered>
                        <span>Não foram encontrados dados.</span>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-dark">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="loading-text">Carregando...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <div class="actions-icons">
                        <btn-excluir :idItem="row.item.Id" :excluirItem="removerEnvioSM" />
                        </div>
                    </template>
                </b-table>
                <table-pagination v-if="totalRows" :total-rows="totalRows" per-page="10" @pageChange="novaPagina">
                </table-pagination>
            </b-card-body>
        </b-card>
    </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue'
import enviosSMService from "@/services/administracao/enviosSMService"
import { store } from "@/store"
import Multiselect from "vue-multiselect";
import { SelectValue } from '@/types/select-value'
import { FiltrosEnviosSM } from '@/types/administracao/filtros-envios-sem-movimento'
import { EnviosSM } from '@/types/administracao/envios-sm'
import { fieldsEnviosSM } from '@/types/administracao/fields-envios-sm'
import { TableField } from '@/types/table-field'
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import ugService from "@/services/administracao/ugService"
import { UnidadeGestoraResumida } from '@/types/ug/unidade-gestora-resumida';
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'

const CompProps = Vue.extend({
  name: 'EnviosSemMovimento',
  components: { BtnExcluir, CardFiltrosBusca, Multiselect, TablePagination },
})

@Component
export default class EnvioSM extends mixins(UtilsTS, CompProps) {
    comboExercicios: SelectValue[] = []
    comboReferencias: SelectValue[] = []
    optionsUG: UnidadeGestoraResumida[] = []
    filtros: FiltrosEnviosSM = new FiltrosEnviosSM()
    fields: TableField[] = fieldsEnviosSM
    currentPage = 1
    totalRows = 0
    items: EnviosSM[] = []
    tableBusy = false
    isBusy = false
    showFilters = true

    async mounted() {
        try {
            store.blockScreen = true
            const ano = new Date().getFullYear()
            this.comboExercicios = [
                { text: String(ano - 1), value: ano - 1 },
                { text: String(ano), value: ano },
                { text: String(ano + 1), value: ano + 1 },
            ]
            this.comboReferencias = [1,2,3,4,5,6,7,8,9,10,11,12,13,14].map(r => {
                return { text: String(r), value: r }
            })
            await this.obterUgsAtivas()
            this.buscarEnviosSM()
        } finally {
            store.blockScreen = false
        }
    } 

    limparFiltros(): void {
        this.filtros.limpar()
        // Trick to reset/clear native browser form validation state
        this.showFilters = false
        this.novaPagina(1)
        this.$nextTick(() => {
        this.showFilters = true
        })
    }

    executarFiltros(): void {
        this.currentPage = 1
        this.buscarEnviosSM()
    }

    novaPagina(page): void {
        this.currentPage = page
        this.buscarEnviosSM()
    }

    async obterUgsAtivas(): Promise<void> {
        try {
            const response = await ugService.obterUgsAtivas()
            if (response && response.status === 200) {
                this.optionsUG = this.formatedUGLabels(response.data)
            } else {
                throw new Error(response.data && response.data.msg ? response.data.msg : 'Ocorreu um erro ao buscar UGs ativas!')
            }
        } catch (e: any) {
            console.error(e)
            this.$toast.error(e.message ? e.message : e);
        } finally {
            this.isBusy = false
        }
    }

    async buscarEnviosSM(): Promise<void> {
        this.tableBusy = true
        try {
            const response = await enviosSMService.buscarEnviosSM(this.filtros, this.currentPage);
            if (response && response.status === 200) {
                this.items = response.data.autorizacoes.map((pr: any) => {
                    const retorno = Object.assign(new EnviosSM(), pr)
                    return retorno
                })
                this.totalRows = response.data.totalRows
            } else {
                throw new Error(response.data && response.data.msg ? response.data.msg : 'Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!')
            }
        } catch (e: any) {
            console.error(e)
            this.items = []
            this.totalRows = 0
            this.$toast.error(e.message ? e.message : e);
        } finally {
            this.tableBusy = false
        }
    }

    async removerEnvioSM(id: number): Promise<void> {
        try {
        store.blockScreen = true
        const resp = await enviosSMService.removerEnviosSM(id)
        if (resp && resp.status === 200) {
            this.buscarEnviosSM()
            this.$toast.success("Autorização para envio sem movimento excluída com sucesso")
        } else {
            console.error('Erro ao remover autorização', resp)
            this.$toast.error(resp.data.msg || 'Erro ao remover autorização!')
        }
        } catch (e: any) {
        console.error('Erro ao remover autorização', e)
        this.$toast.error(e.message || 'Erro ao remover autorização')
        } finally {
        store.blockScreen = false
        }
    }


};
</script>

